module.exports = __webpack_public_path__ + "884c46c718cbb212a5a431350ae8fc10.pdf";